import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import getUserInitials from '../../utils/getUserInitials';
import { getFullImageUrl } from '../../utils/api/services/image';

export default class UserSmallAvatar extends Component {
  static defaultProps = {
    color: ''
  };

  static propTypes = {
    user: PropTypes.object.isRequired,
    color: PropTypes.string
  };

  render() {
    const { color } = this.props;
    const pictureUrl = this.props.user.picture;
    const fullName = `${this.props.user.firstName} ${this.props.user.lastName}`;
    const initials = getUserInitials(fullName) || fullName;
    const avatarBackgroundSettings = {
      backgroundColor: color,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    };
    const avatarImage = pictureUrl && { backgroundImage: ` url(${getFullImageUrl(pictureUrl)})` };
    const avatarStyles = { ...avatarBackgroundSettings, ...avatarImage };
    return (
      <div className="themes-list__user">
        {pictureUrl ? (
          <div
            className="themes-list__user-avatar"
            alt={initials}
            style={avatarStyles}
          />
        ) : (
          <div
            className="themes-list__user-avatar themes-list__user-avatar--no-image"
            style={avatarStyles}
          >
            {initials}
          </div>
        )}
        <div className="themes-list__user-name button__hint">{fullName}</div>
      </div>
    );
  }
}
